import { render } from "./ListadoVentasInstaladas.vue?vue&type=template&id=7851cdb8"
import script from "./ListadoVentasInstaladas.vue?vue&type=script&lang=js"
export * from "./ListadoVentasInstaladas.vue?vue&type=script&lang=js"

import "./ListadoVentasInstaladas.vue?vue&type=style&index=0&id=7851cdb8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__